import React from "react"
import Project from "./Project"
import { Link } from "gatsby"
import styled from "styled-components"

const StyledLink = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  .email-link {
    margin-top: 48px;
    color: #d1f7ff;
    background-color: transparent;
    border: 1px solid #d1f7ff;
    border-radius: 4px;
    padding: 1.25rem 1.75rem;
    font-size: 16px;
    font-family: poppins;
    line-height: 1;
    text-decoration: none !important;
    cursor: pointer;
    transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
    &:hover,
    &:focus,
    &:active {
      background-color: rgba(100, 255, 218, 0.1);
      outline: none;
    }
    &:after {
      display: none !important;
    }
  }
`
export default function Projects({ projects, title, showLink }) {
  return (
    <section id="projects">
      <h2 className="numbered-heading">{title}</h2>
      <Project />
      <StyledLink>
        {showLink && (
          <Link className="email-link" to="/Projects">
            view more
          </Link>
        )}
      </StyledLink>
    </section>
  )
}
